import type { HrcConnectSubject } from './types'

export function hasHealthRecordsConnectionNeedingAttention(subject: HrcConnectSubject): boolean {
  return (
    subject.healthSystems?.some(
      ({ state, verificationFailed }) => state === 'EXPIRED' || verificationFailed === true
    ) ?? false
  )
}
